import * as React from 'react';
import { cn } from '@/lib/utils';
import { Label } from '@/components/ui/label';
import { ComboboxSingle } from '@/components/ui/combobox-single';
import { ComboboxMultiple } from '@/components/ui/combobox-multiple';
import { Field } from '@/components/ui/field';

export const FormCombobox = React.forwardRef(
  (
    {
      // props
      id,
      className,
      options = [],
      placeholder = 'Selecione...',
      loading = false,
      emptyMessage = 'Nenhum resultado encontrado.',
      label = '',
      multiple = false,
      disabled = false,
      ...props
    },
    ref
  ) => {
    const generatedId = React.useId();
    const filterId = id || generatedId;

    return (
      <Field
        ref={ref}
        className={cn('c-form-combobox', disabled && '[&>label]:cursor-not-allowed [&>label]:opacity-50', className)}
      >
        {label && <Label htmlFor={filterId}>{label}</Label>}
        {multiple ? (
          <ComboboxMultiple
            id={filterId}
            options={options}
            placeholder={placeholder}
            loading={loading}
            emptyMessage={emptyMessage}
            disabled={disabled}
            {...props}
          />
        ) : (
          <ComboboxSingle
            id={filterId}
            options={options}
            placeholder={placeholder}
            loading={loading}
            emptyMessage={emptyMessage}
            disabled={disabled}
            {...props}
          />
        )}
      </Field>
    );
  }
);

FormCombobox.displayName = 'FormCombobox';
